import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormsUtilsService, MessageService, notCloseMessageOptions } from '../../../../core';

@Component({
    selector: 'sgt-sob-demanda-form-control-radio',
    templateUrl: './sob-demanda-form-control-radio.component.html',
    styleUrls: ['./sob-demanda-form-control-radio.component.less']
})
export class SobDemandaFormControlComponent {
    @Input() sobDemanda: boolean;
    @Output() sobDemandaChange =  new EventEmitter<boolean>();
    @Input() required = true;
    @Input() canEdit = true;
    @Input() inputLabel = 'Sob demanda?';
    @Input() msgRequiredError = 'É obrigatório informar a opção de sob demanda';
    @Input() inputHelpText: string = null;
    @Input() name = 'sobDemanda';
    @Input() id = 'sobDemanda';

    @ViewChild('form') form: NgForm;

    constructor(private formsUtilsService: FormsUtilsService,
                private messageService: MessageService) { }

    /** Ao alterar a flag de sob demanda */
    onChange(value: boolean) {
        this.sobDemanda = value;
        this.sobDemandaChange.emit(this.sobDemanda);
    }

    /** Verifica se a flag sob demanda está válida */
    isValid(): boolean {
        // Se não puder editar ou não for obrigatório selecionar a flag de sob demanda, então tudo ok
        if (!this.required || !this.canEdit) {
            return true;
        }

        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // É válido quando estiver selecionado a flag de sob demanda
        if (this.sobDemanda == null || this.sobDemanda === undefined) {
            this.messageService.warning(this.msgRequiredError, 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
